import { Component, input } from '@angular/core';
import { SupplierContractCheckData } from '../../stores/supplier-contract-checks.store';
import { SupplierContractCheckItem } from '../supplier-contract-check-item/supplier-contract-check-item';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-supplier-contract-check',
  imports: [SupplierContractCheckItem, TranslocoPipe],
  templateUrl: './supplier-contract-check.html',
})
export class SupplierContractCheck {
  data = input.required<SupplierContractCheckData>();
  organizationId = input.required<string>();
}
